import React, { useState, useRef, useEffect } from "react";
import "./AddTaskGroup.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { colorOptions, normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";
import { useTranslation } from "react-i18next";

function AddTaskGroup({ createTaskGroup, cancelCreateTaskGroup }) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]);
  const [showNameError, setShowNameError] = useState(false);

  const handleCreateTaskGroup = () => {
    if (name.trim()) {
      const colorHex = normalizeColor(selectedColor);
      createTaskGroup(name.trim(), colorHex);
      setName("");
      setSelectedColor(colorOptions[0]);
      setShowNameError(false);
    } else {
      setShowNameError(true);
    }
  };

  // Til at sætte focus på inputfeltet når modal åbnes
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="add-task-group-content">
      <div className="modal-title">
        <div>{t("tasks.modals.addTaskGroup.title")}</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">{t("common.name")}</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder={t("tasks.modals.addTaskGroup.namePlaceholder")}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (showNameError && e.target.value.trim()) {
              setShowNameError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleCreateTaskGroup();
            }
          }}
        />
        {showNameError && (
          <div className="modal-helper-text">
            {t("tasks.group.nameRequired")}
          </div>
        )}

        <div className="modal-form-title">{t("common.color")}</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>

        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              setName("");
              setSelectedColor("");
              setShowNameError(false);
              cancelCreateTaskGroup();
            }}
          >
            {t("common.cancel")}
          </button>
          <button className="modal-button save" onClick={handleCreateTaskGroup}>
            {t("common.create")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddTaskGroup;
